import { render, staticRenderFns } from "./NotificaDepartamental.vue?vue&type=template&id=d580cb08&"
import script from "./NotificaDepartamental.vue?vue&type=script&lang=js&"
export * from "./NotificaDepartamental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports